export enum GoLocationType {
    Fixed = 'Fixed',
    MobileOnly = 'MobileOnly',
}

export const GoLocationTypeToLabelMapping = {
    [GoLocationType.Fixed]: 'Fixed',
    [GoLocationType.MobileOnly]: 'Mobile Only',
};
